// Bottom toast update notification — shown when a new service worker is waiting

import { useTranslation } from 'react-i18next'
import { usePWAUpdate } from '@/hooks/usePWAUpdate'

export function UpdatePrompt() {
  const { t } = useTranslation()
  const { needRefresh, dismissUpdate, applyUpdate } = usePWAUpdate()

  if (!needRefresh) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 bg-card border border-border rounded-lg shadow-lg p-4 flex items-center justify-between z-50">
      <span className="text-sm text-foreground">{t('pwa.update.message')}</span>
      <div className="flex gap-2">
        <button
          onClick={dismissUpdate}
          className="text-sm text-muted-foreground px-3 py-1"
        >
          {t('pwa.update.notNow')}
        </button>
        <button
          onClick={applyUpdate}
          className="text-sm bg-primary text-primary-foreground px-3 py-1 rounded-md"
        >
          {t('pwa.update.update')}
        </button>
      </div>
    </div>
  )
}
